import styled, { css } from 'styled-components';

type HeightProps = {
  $height: number;
};

export const ChartCard = styled.article`
  ${({ theme }) => css`
    min-width: 0;
    padding: ${theme.spacings[20]};
    display: flex;
    flex-direction: column;
    border: 1px solid ${theme.colors.gray200};
    border-radius: ${theme.radius.md};
    background: ${theme.colors.white};
    box-shadow: 0 0.8rem 2.4rem rgba(36, 44, 92, 0.08);
  `}
`;

export const ChartHeader = styled.header`
  ${({ theme }) => css`
    min-height: 5.2rem;
    margin-bottom: ${theme.spacings[12]};

    h3 {
      color: ${theme.colors.indigo800};
      font-size: ${theme.font.sizes.md};
      font-weight: ${theme.font.weights.bold};
      line-height: 1.3;
    }

    p {
      margin-top: ${theme.spacings[4]};
      color: ${theme.colors.gray600};
      font-size: ${theme.font.sizes.xs};
      line-height: 1.4;
    }
  `}
`;

export const ChartArea = styled.div<HeightProps>`
  ${({ $height }) => css`
    width: 100%;
    height: ${$height}px;
    overflow: hidden;
  `}
`;

export const ChartLoading = styled.div`
  ${({ theme }) => css`
    height: 100%;
    display: grid;
    place-items: center;
    color: ${theme.colors.gray600};
    font-size: ${theme.font.sizes.sm};
  `}
`;

export const EmptyChart = styled.div<HeightProps>`
  ${({ theme, $height }) => css`
    height: ${$height}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[8]};
    border-radius: ${theme.radius.sm};
    background: ${theme.colors.gray50};
    color: ${theme.colors.gray600};
    text-align: center;

    strong {
      color: ${theme.colors.blueGray700};
      font-size: ${theme.font.sizes.sm};
    }

    span {
      font-size: ${theme.font.sizes.xs};
    }
  `}
`;
